import React from "react";
import Button from "@atoms/Button/Button";
import Title from "@atoms/Title/Title";
import { CgChevronLeft, CgClose } from "react-icons/cg";
import "./Dialog.scss";
import DialogHeader from "./DialogHeader";

interface Props {
	title: string;
	onBackButtonClick?: VoidFunction;
	onCloseButtonClick?: VoidFunction;
	hasDivider?: boolean;
}

const DialogFullHeader: React.FC<Props> = ({
	title,
	onBackButtonClick,
	onCloseButtonClick,
	hasDivider,
}) => {
	const hideModal = () => {
		onCloseButtonClick && onCloseButtonClick();
	};

	return (
		<DialogHeader hideModal={hideModal} hasDivider={hasDivider}>
			{onBackButtonClick && (
				<div className="DialogFullHeader--left">
					<Button
						size="l"
						variant="inline"
						label={<CgChevronLeft size="25" />}
						onClick={onBackButtonClick}
					/>
				</div>
			)}
			{title && (
				<Title size="s" align="center">
					{title}
				</Title>
			)}

			{onCloseButtonClick && (
				<div className="DialogFullHeader--right">
					<Button
						size="l"
						variant="inline"
						label={<CgClose size="22" />}
						onClick={onCloseButtonClick}
					/>
				</div>
			)}
		</DialogHeader>
	);
};
export default DialogFullHeader;
